import React from 'react';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import { closeModal } from 'store/modals/actions';
import { MODAL_CANT_CREATE } from 'store/modals/modals';
import ConfirmNavigationModal from 'Common/Components/ConfirmNavigationModal';
import { redirectToHost } from 'store/Contextualization/AssetDetail/actions';
import { redirect } from 'store/Router/actions';
import { redirectToHostsGeneral } from 'store/HostsGeneral/actions';

const WarningModal = ({ entity, noAssetsInAllWorkspaces, noWorkspaces }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const cantCreate = intl.formatMessage({ id: 'modal.cantCreate' });
  const title = `${cantCreate} ${entity}`;
  const message = noWorkspaces ? intl.formatMessage({ id: 'modal.cantCreate.general' }) : intl.formatMessage({ id: 'modal.cantCreate.vulns' });
  const cancel = noWorkspaces ? intl.formatMessage({ id: 'modal.cantCreate.toWorkspaces' }) : intl.formatMessage({ id: 'modal.cantCreate.toAssets' });

  const onDone = () => {
    if (noWorkspaces) dispatch(redirect('/workspaces'));
    else if (noAssetsInAllWorkspaces) dispatch(redirectToHostsGeneral());
    else dispatch(redirectToHost());
    dispatch(closeModal(MODAL_CANT_CREATE));
  };

  const onCancel = () => {
    dispatch(closeModal(MODAL_CANT_CREATE));
  };

  return (
    <ConfirmNavigationModal
      title={ title }
      message={ message }
      onCancel={ onCancel }
      onDone={ onDone }
      cancel="Close"
      done={ cancel }
    />
  );
};

export default WarningModal;
